import { type Configuration, type PopupRequest } from '@azure/msal-browser'

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || 'your-client-id',
    authority: import.meta.env.VITE_ENTRA_AUTHORITY || 'https://login.microsoftonline.com/your-tenant-id',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}

export const loginRequest: PopupRequest = {
  scopes: [
    'openid',
    'profile',
    'User.Read',
    import.meta.env.VITE_API_SCOPE || 'api://your-api-client-id/access_as_user'
  ],
  prompt: 'select_account'
}

export const tokenRequest = {
  scopes: [
    import.meta.env.VITE_API_SCOPE || 'api://your-api-client-id/access_as_user'
  ]
}
